export enum DEALERS_LICENSES_STORAGE_KEYS {
  DealerPreference = "dealer-licenses-dealer-preference"
}
